import { APICall } from ".."

const ControllerName = "MobDecisionMedicines"

export const GetPatientDecisions = (searchData: any) => {

    const keyword = searchData.keyword
    const textKeyword = searchData.textKeyword

    return APICall("get", ControllerName + `/GetPatientDecisions?keyword=${keyword || ""}&textKeyword=${textKeyword || ""}`)
}

export const GetDecisionMedicineForUpdate = (id: number) => {
    return APICall("get", ControllerName + `/GetDecisionMedicinesForUpdate?decisionId=${id}`)
}

export const CalcMedicineDurationCost = (data: any, pharmId: any, hosId: any) => {
    return APICall("post", ControllerName + `/CalcMedicineDurationCost?pharmacyId=${pharmId || ""}&hospitalId=${ hosId || ""}`, data)
}

export const SubmitNewDecisionMedicines = (data: any) => {
    return APICall("post", ControllerName + "/SubmitNewDecisionMedicines", data)
}